/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import {
  GDSStackLayoutProps,
  StackItem,
  StackLayout,
} from '@leagueplatform/genesis-core';
import {
  EVENT_NAME,
  PRODUCT_AREA,
  trackAnalyticsEvent,
} from '@leagueplatform/analytics';
import {
  ErrorState as WebCommonErrorState,
  ErrorStateProps as WebCommonErrorStateProps,
} from '@leagueplatform/web-common-components';
import {
  ERROR_TYPES,
  useErrorMessage,
} from '../../hooks/use-error-message/use-error-message';
import { FullScreenContainer } from '../full-screen-container.component';
import { useIsBelowTablet } from '../../hooks/use-is-below-tablet/use-is-below-tablet.hook';
import {
  ANALYTICS_SCREEN_NAMES,
  SUB_PRODUCT_AREA_NAMES,
} from '../../common/constants';

export type ErrorStateProps = WebCommonErrorStateProps & {
  isFullPage?: boolean;
  styleProps?: Partial<GDSStackLayoutProps>;
  errorType?: ERROR_TYPES;
  hideButton?: boolean;
  headingString?: string;
  bodyString?: string;
  buttonText?: string;
  buttonAction?: () => void;
};

export const ErrorState = ({
  styleProps,
  isFullPage = false,
  hideButton = false,
  ...errorData
}: ErrorStateProps) => {
  const errorContent = useErrorMessage(errorData);
  const isBelowTablet = useIsBelowTablet();

  const CONTAINER_WIDTH = '708px';

  useEffect(() => {
    trackAnalyticsEvent(EVENT_NAME.SCREEN_LOADED, {
      product_area: PRODUCT_AREA.LOGIN,
      sub_product_area: SUB_PRODUCT_AREA_NAMES.SIGN_IN,
      screen_name: ANALYTICS_SCREEN_NAMES.GENERIC_ERROR,
    });
  }, []);

  if (isFullPage) {
    return (
      <FullScreenContainer
        horizontalAlignment="center"
        css={{
          backgroundColor: isBelowTablet
            ? 'none'
            : '$surfaceBackgroundSecondary',
        }}
      >
        <StackLayout
          verticalAlignment="center"
          {...styleProps}
          css={{
            textAlign: 'center',
            maxWidth: isBelowTablet ? '350px' : 'none',
            ...styleProps?.css,
          }}
        >
          <StackItem
            css={{
              background: '$surfaceCardSecondary',
              paddingBlock: isBelowTablet ? 'none' : '$twoAndHalf',
              width: isBelowTablet ? 'none' : CONTAINER_WIDTH,
            }}
          >
            <WebCommonErrorState hideButton={hideButton} {...errorContent} />
          </StackItem>
        </StackLayout>
      </FullScreenContainer>
    );
  }

  return (
    <StackLayout
      {...styleProps}
      css={{
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        ...styleProps?.css,
      }}
    >
      <WebCommonErrorState {...errorContent} />
    </StackLayout>
  );
};
